import React from "react";

interface TooltipIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  className?: string;
}

const NewPageIcon: React.FC<TooltipIconProps> = ({ size = 28, color = '003366', className, ...props }) => (
  <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.3332 9.62468V20.9997C23.3332 24.4997 21.2448 25.6663 18.6665 25.6663H9.33317C6.75484 25.6663 4.6665 24.4997 4.6665 20.9997V9.62468C4.6665 5.83301 6.75484 4.95801 9.33317 4.95801C9.33317 5.68134 9.62481 6.33467 10.1031 6.813C10.5815 7.29134 11.2348 7.58301 11.9582 7.58301H16.0415C17.4882 7.58301 18.6665 6.40467 18.6665 4.95801C21.2448 4.95801 23.3332 5.83301 23.3332 9.62468Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M18.6668 4.95801C18.6668 6.40467 17.4885 7.58301 16.0418 7.58301H11.9585C11.2352 7.58301 10.5818 7.29134 10.1035 6.813C9.62513 6.33467 9.3335 5.68134 9.3335 4.95801C9.3335 3.51134 10.5118 2.33301 11.9585 2.33301H16.0418C16.7652 2.33301 17.4185 2.62468 17.8969 3.10301C18.3752 3.58135 18.6668 4.23467 18.6668 4.95801Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.3335 15.167H14.0002" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.3335 19.833H18.6668" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);

export default NewPageIcon;
